import { DashboardLayout } from "../components/DashboardLayout";

export default [DashboardLayout];